import { AnalyticsBar, BoltIcon, BuildingOfficeIcon, ClockIcon, FireIcon } from 'components'
import { AggregationData } from 'types'
import { useAggregations } from '../../utils/analyticsUtils'

export default function OnTheGoAnalyticsBar() {
  const { aggregations } = usePrimaryOtgMemberAggregations()

  return (
    <AnalyticsBar
      aggregations={aggregations}
      excludeLabels={['Companies', 'Schools', 'Avg. Session Duration']}
    />
  )
}

function usePrimaryOtgMemberAggregations() {
  return useAggregations([
    {
      table: 'leads',
      values: ['_count'],
      otherProps: {
        Icon: BoltIcon,
        label: 'Total Leads',
        formatData: (data: AggregationData) => Number(data?.[0]?._count),
      },
    },
    {
      table: 'leads',
      values: ['_count'],
      filters: [{ field: 'temp', operator: 'eq', value: 'hot', table: 'leads' }],
      otherProps: {
        Icon: FireIcon,
        label: 'Hot Leads',
        formatData: (data: AggregationData) => Number(data?.[0]?._count),
      },
    },
    {
      table: 'leads',
      values: ['_count'],
      filters: [{ field: 'company', operator: 'isNull', value: false, table: 'leads' }],
      otherProps: {
        Icon: BuildingOfficeIcon,
        label: 'Companies',
        formatData: (data: AggregationData) => Number(data?.[0]?._count),
      },
    },
    {
      table: 'leads',
      values: ['_count'],
      filters: [{ field: 'school', operator: 'isNull', value: false, table: 'leads' }],
      otherProps: {
        Icon: BuildingOfficeIcon,
        label: 'Schools',
        formatData: (data: AggregationData) => Number(data?.[0]?._count),
      },
    },
    {
      categories: ['title'],
      filters: [
        { field: 'groupTitle', operator: 'eq', value: '_default', table: 'sessionMetrics' },
      ],
      table: 'sessionMetrics',
      values: ['duration_avg'],
      otherProps: {
        Icon: ClockIcon,
        label: 'Avg. Session Duration',
        formatData: (data: AggregationData) =>
          data?.reduce((acc, curr) => acc + (Number(curr.duration_avg) || 0), 0) || 0,
      },
    },
  ])
}
